export function sortByOrder( a, b ){
	return +a.order - +b.order;
}